import { jsx as _jsx } from "react/jsx-runtime";
import { useGlobalStore } from '../../../store/global';
import { useProductStore } from '../../../store/product';
import { useVariantsStore } from '../../../store/variants';
export default function Color({ attribute }) {
    const settings = useGlobalStore((state) => state.config.template_settings);
    let variants = useProductStore((state) => state.product.variants);
    if (!variants)
        variants = useVariantsStore((state) => state.variants);
    const selectedValues = useVariantsStore((state) => state.selectedValues);
    const updateSelectedValue = useVariantsStore((state) => state.updateSelectedValue);
    if (settings.product_detail.show_variant_images_instead_of_color.enabled) {
        const grouped = groupByColors(variants, attribute.values);
        _jsx("div", { className: "attribute-color", children: grouped.map((value) => {
                const selected = selectedValues.some((selectedValue) => selectedValue.attribute.id === value.value.attribute_id && selectedValue.value.id === value.value.id);
                return value.images.flatMap((image, i) => {
                    return (_jsx("img", { alt: `attribute-image-${i}`, src: image, onChange: () => {
                            if (!selected)
                                updateSelectedValue({ attribute, value: value.value });
                        }, className: "attribute-color-item", children: selected && _jsx("span", { className: "selected icon icon-check-green-filled" }) }, `image-attribute-${attribute.id}-${i}`));
                });
            }) });
    }
    return (_jsx("div", { className: "attribute-color", children: attribute.values.map((value, i) => {
            const selected = selectedValues.some((selectedValue) => selectedValue.attribute.id === attribute.id && selectedValue.value.id === value.id);
            return (_jsx("div", { onClick: () => {
                    if (!selected)
                        updateSelectedValue({ attribute, value });
                }, className: "attribute-color-item", style: { backgroundColor: value.color }, children: selected && _jsx("span", { className: "selected" }) }, `color-attribute-${i}`));
        }) }));
}
function groupByColors(variants, values) {
    let result = [];
    for (const value of values) {
        const images = new Set();
        for (const variant of variants) {
            const exists = variant.values.some((v) => v.id === value.id);
            if (exists && variant.images.length > 0)
                images.add(variant.images[0].url);
        }
        result.push({ value, images: [...images] });
    }
    return result;
}
